import { render, staticRenderFns } from "./TechnicalDetails.vue?vue&type=template&id=04417b64&scoped=true&"
import script from "./TechnicalDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TechnicalDetails.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TechnicalDetails.vue?vue&type=style&index=0&id=04417b64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04417b64",
  null
  
)

export default component.exports